import { render, staticRenderFns } from "./tipo_vehiculo.vue?vue&type=template&id=2510a5be"
import script from "./tipo_vehiculo.vue?vue&type=script&lang=js"
export * from "./tipo_vehiculo.vue?vue&type=script&lang=js"
import style0 from "./tipo_vehiculo.vue?vue&type=style&index=0&id=2510a5be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports